/* eslint-disable react-hooks/exhaustive-deps */
// disabled due to issues with Formik dependencies that caused inifinite loops
import React from 'react';
import { PropTypes } from 'prop-types';
import { Configure } from 'react-instantsearch-dom';

import SearchHitCollege from '../../_atoms/SearchHitCollege';
import Autocomplete from '@molecules/Autocomplete';
import SearchContainer from '@search/SearchContainer';

const SelectCollegesSearch = ({
    placeholder = 'Search colleges...',
    name,
    label = 'Choose a college',
    onSelect,
    initialRefinement,
}) => (
    <SearchContainer key={`colleges-${name}`} index="colleges">
        <Configure hitsPerPage={5} />
        <Autocomplete
            name={name}
            compHit={SearchHitCollege}
            placeholder={placeholder}
            label={label}
            onSelect={onSelect}
            initialRefinement={initialRefinement}
            listItemMinHeight="77px"
        />
    </SearchContainer>
);

SelectCollegesSearch.propTypes = {
    placeholder: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    initialRefinement: PropTypes.string,
    onSelect: PropTypes.func,
};

export default SelectCollegesSearch;
